import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { securityCheck } from "../../utils/authHelpers";
import { UserPermissionsContext } from "../Dashboard/Dashboard";

export default function SecurityCheck({
  componentName,
  action,
  callbackRequired,
  callback,
  ...props
}) {
  const [actionPerm, setActionPerm] = useState(false);
  const userPermissions = useContext(UserPermissionsContext);

  useEffect(() => {
    if (userPermissions) {
      setActionPerm(securityCheck(userPermissions, componentName, action));
    }
  }, [componentName, action, props.children, userPermissions]);

  useEffect(() => {
    callbackRequired && callback(actionPerm);
  }, [actionPerm, callbackRequired]);

  return actionPerm ? <>{props.children}</> : null;
}

SecurityCheck.propTypes = {
  componentName: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  callbackRequired: PropTypes.bool,
  callback: PropTypes.func,
  children: PropTypes.node
};